import { Pagination, Select } from 'antd'
import classNames from 'classnames'
import { Dispatch, SetStateAction, useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './index.module.less'
import { useGlobalStore } from '@/hoxStore/globalStore'

const MePagination = ({
  total = 0,
  currentPage = 1,
  pageSize = 10,
  loading = false,
  setPageParams,
  nextKeyFn,
  prevKeyFn,
  paginationPreAndNext,
  pageSizeOptions,
  groupIndex = 0, // 组索引
  groupSize = 0, // 组大小
}: {
  total?: number
  currentPage?: number
  pageSize?: number
  loading?: boolean
  setPageParams?: Dispatch<SetStateAction<{ page: number; offset: number; limit: number }>>
  prevKeyFn?: null | (() => void)
  nextKeyFn?: null | (() => void)
  paginationPreAndNext?: {
    canNext: boolean
    canPrev: boolean
  }
  pageSizeOptions?: number[]
  groupIndex?: number // 组索引
  groupSize?: number // 组大小
}) => {
  const { curReponsive } = useGlobalStore()
  const currentPageRef = useRef(pageSize)
  const { t } = useTranslation()
  const [goToPage, setGoToPage] = useState<string | number>('')
  const onChange = (page: number) => {
    const offset = (page - 1) * pageSize
    setPageParams?.({
      page,
      offset,
      limit: pageSize,
    })
  }

  const handlePageSizeChange = (value: number) => {
    setPageParams?.({
      page: 1,
      offset: 0,
      limit: value,
    })
  }

  /** 分页选项 */
  const options = useMemo(() => {
    if (pageSizeOptions) {
      return pageSizeOptions?.map((item) => {
        return { value: item, label: `${item}/${t('explorer_397')}` }
      })
    }
    return [
      { value: 10, label: `10/${t('explorer_131')}` },
      { value: 20, label: `20/${t('explorer_131')}` },
      { value: 50, label: `50/${t('explorer_131')}` },
      { value: 100, label: `100/${t('explorer_131')}` },
    ]
  }, [pageSizeOptions])

  // 失焦
  const hanleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const value = Number(goToPage) > maxPage ? maxPage : Number(goToPage)
    if (Number(value) - 1 < 0) return
    setPageParams?.({
      page: Number(value),
      offset: (Number(value) - 1) * pageSize,
      limit: pageSize,
    })
    setGoToPage(value)
  }

  const maxPage = useMemo(() => {
    return Math.ceil(total / pageSize)
  }, [total, pageSize])

  // 回车
  const handleKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const value = Number(goToPage) > maxPage ? maxPage : Number(goToPage)
    if (Number(value) - 1 < 0) return
    if (e.key === 'Enter') {
      setPageParams?.({
        page: Number(value),
        offset: (Number(value) - 1) * pageSize,
        limit: pageSize,
      })
      setGoToPage(value)
    }
  }
  if (Number(total) === 0) return null
  return (
    <div className={'gea_pagination_wrap'}>
      <div className="gea_pagination_line">
        {/* 上一组 */}
        {prevKeyFn && (
          <div
            onClick={() => {
              if (loading) return
              prevKeyFn?.()
            }}
            className={classNames({
              ['ant-pagination-item-group']: true,
              ['ant-pagination-item-group-left']: true,
              [styles.mePaginationDisabled_left]: !paginationPreAndNext?.canPrev || loading,
            })}
          ></div>
        )}

        <Pagination
          disabled={loading}
          current={currentPage}
          total={total}
          pageSize={pageSize}
          // showSizeChanger
          showQuickJumper={false}
          showSizeChanger={false}
          // showQuickJumper
          // showSizeChanger
          itemRender={(page, type, originalElement) => {
            // 跳转按钮不显示
            if (
              type === 'next' ||
              type === 'prev' ||
              type === 'jump-next' ||
              type === 'jump-prev'
            ) {
              return originalElement
            }
            // 分页按钮显示，设置 title 使其与页码同步
            const pageNum = Number(groupIndex * groupSize) / 10 + page
            return (
              <div className={styles.cus_pagination_item} title={String(pageNum)}>
                {pageNum}
              </div>
            )
          }}
          showLessItems={curReponsive?.size === 'mobile'}
          onChange={onChange}
          jumpNextIcon={<div>...</div>}
          jumpPrevIcon={<div>...</div>}
          locale={{
            items_per_page: t('explorer_46'), // 条/页
            jump_to: t('explorer_45'), // 跳至
            page: '',
          }}
        />
        {/* 下一组 */}
        {nextKeyFn && (
          <div
            className={classNames({
              ['ant-pagination-item-group']: true,
              ['ant-pagination-item-group-right']: true,
              [styles.mePaginationDisabled_right]: !paginationPreAndNext?.canNext || loading,
            })}
            onClick={() => {
              if (loading) return
              nextKeyFn?.()
            }}
          ></div>
        )}
      </div>
      {/* <div className="gea_pagination_line">
        <div className={styles.pagination_go_to}>
          <span className={styles.pagination_go_to_label}>GO TO</span>
          <input
            className={'pagination_go_to_input'}
            type={curReponsive?.size === 'mobile' ? 'number' : 'text'}
            inputMode={curReponsive?.size === 'mobile' ? 'numeric' : 'search'}
            value={goToPage}
            onChange={(e) => {
              if (loading) return
              if (/^\d*$/.test(e.target.value) || e.target.value === '') {
                setGoToPage(e.target.value)
              }
            }}
            onBlur={(e) => {
              hanleBlur(e)
            }}
            onKeyUp={(e) => {
              handleKeyUp(e)
            }}
          />
        </div>
        <div className={styles.pagination_select}>
          <Select
            defaultValue={pageSize}
            style={{ width: 100 }}
            className={styles.paginationSelect}
            options={options}
            onChange={(value) => {
              handlePageSizeChange(value)
            }}
          />
        </div>
      </div> */}
    </div>
  )
}

export default MePagination

// locale={{
//     items_per_page: '条/页',
//     jump_to: '跳至',
//     jump_to_confirm: '确定',
//     page: '',
//     prev_page: '上一页',
//     next_page: '下一页',
//       prev_5: '向前5页',
//       next_5: '向后5页',
//       prev_3: '向前3页',
//       next_3: '向后3页',
//   }}
